module.exports = __webpack_public_path__ + "static/cw.469a2aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cw.jpg
// module id = 181
// module chunks = 35783957827783 236645034235845